import { Card } from '@heroui/react';
import { FC, useEffect, useState } from 'react';
import { useAppSelector } from '../../../core/rootHooks';
import { selectOutputStats } from '../../sharedSelectors';
import { selectIsSubscriptionDataFetched } from '../../../user-management/appSelectors';

const Stats: FC = () => {
	const selectedVesselsStats = useAppSelector(selectOutputStats);
	const isSubscriptionDataFetched = useAppSelector(selectIsSubscriptionDataFetched);

	const [screenHeight, setScreenHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => setScreenHeight(window.innerHeight);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const positionClass = screenHeight < 700 ? 'bottom-52 right-56' : 'bottom-36 right-2';

	return (
		isSubscriptionDataFetched && (
			<Card className={`fixed w-44 z-30 p-2 opacity-85 rounded-none m-0 ${positionClass}`}>
				<div className="flex flex-col space-y-0">
					<div className="flex justify-between">
						<span className="text-msi-midblue-color-500 "># Vessels:</span>
						<span>{selectedVesselsStats.vesselCount}</span>
					</div>
					<div className="flex justify-between">
						<span className="text-msi-midblue-color-500"># Sectors:</span>
						<span>{selectedVesselsStats.sectorCount}</span>
					</div>
					<div className="flex justify-between">
						<span className="text-msi-midblue-color-500"># Owners:</span>
						<span>{selectedVesselsStats.ownershipCount}</span>
					</div>
				</div>
			</Card>
		)
	);
};

export default Stats;
